import { Observable } from "rxjs";
import { CommonHttpOption } from "./../../base/common-http-option";
import { ServiceRoute } from "src/app/services/http/base/service-route";
import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";

@Injectable({
  providedIn: 'root'
})
export class MarketerService {

  constructor(private core: CoreService) { }

  save(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.marketer.save,
      data,
      new CommonHttpOption().headers
    );
  }

  list(CompanyEncryptId: string, PersonEncryptId: string, page = 1, pageSize = 10): Observable<any> {
    var url = ServiceRoute.marketer.list + CompanyEncryptId;
    if (PersonEncryptId) {
      url += '&PersonEncryptId=' + PersonEncryptId;
    }
    return this.core.get(
      url,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  delete(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.marketer.delete,
      data,
      new CommonHttpOption().headers
    );
  }

}
